var createListItem__Register = function (result) {
    var template = '<div class="search-dropdown__item aaa">\
        <a href="' + result.id + '" class="search-result search-result--store-link">\
            <div class="search-result__meta search-result__school-name" data-id="' + result.id + '">' + result.name + ' - ' + result.city + '</div>\
        </a>\
    </div>';

    return template;
}

var StoreSearch__Register = function (element) {
    var $element = $('#' + element);
    this.xhr = null;

    this.cache = {
        $wrapper: $element,
        $element: $element.find('input.form-control--school').first(),
        $resultList: null,
        searchTerm: $element.val(),
        selectedFilter: 'school',
        results: []
    }

    this.eventListeners();
}

StoreSearch__Register.prototype.eventListeners = function () {
    this.cache.$element.on('keyup', function (event) {
        if (!event.originalEvent) {
            return;
        }

        this.cache.searchTerm = event.target.value;
        this.search();
    }.bind(this));
}

StoreSearch__Register.prototype.search = function () {
    if (this.xhr) {
        this.xhr.abort();
    }

    this.xhr = $.ajax({
        type: 'GET',
        crossDomain: false,
        url: 'https://www.gradwear.ca/apps/rep/school?filterable_col=name&filterable_val=' + encodeURI(this.cache.searchTerm),
        dataType: 'json',
        success: function (response) {
            if (typeof response == 'object' && !response.hasOwnProperty('data')) {
                this.cache.results = [];
            } else {
                this.cache.results = response.data;
            }

            this.showResults();
        }.bind(this)
    })
}

StoreSearch__Register.prototype.showResults = function () {
    if (this.cache.searchTerm.length) {
        if (!this.cache.$resultList) {
            var $resultList = $('<div class="search-dropdown__content"></div>');
            this.cache.$resultList = $resultList;
            $resultList.appendTo(this.cache.$wrapper.find('.search-dropdown__scroller'));
        }

        this.cache.$resultList.empty();

        if (this.cache.results.length > 0) {
            for (var i = 0; i < this.cache.results.length; i++) {
                var result = this.cache.results[i];
                this.cache.$resultList.append(createListItem__Register(result));
            }
        }

        this.cache.$resultList.append('<div class="search-dropdown__item">\
                <a href="#add_school" data-toggle="modal" class="search-result search-result--store-link">\
                    <div class="search-result__meta search-result__school-name">+ ADD SCHOOL</div>\
                </a>\
            </div>\
        ');

        this.mapSchoolInfo();

        this.cache.$element[0].dispatchEvent(new CustomEvent('postSearch'));
    } else {
        if (this.cache.$resultList) {
            this.cache.$resultList.remove();
            this.cache.$resultList = null;
        }
    }
}

StoreSearch__Register.prototype.mapSchoolInfo = function () {
    let $element = this.cache.$element;
    let $wrapper = this.cache.$wrapper;

    this.cache.$resultList.on('click', function (event) {
        event.preventDefault();
        let $school = $(event.target).hasClass('search-result--store-link') ? $(event.target) : $(event.target).parents('.search-result--store-link');
        $school = $school.find('.search-result__school-name');
        let schoolName = $school.text();
        let schoolId = $school.data('id');


        if (schoolName != '+ ADD SCHOOL') {
            $element.val(schoolName);
            $element.prev().val(schoolId);
        }

        $wrapper.find('.search-dropdown').removeClass('is-shown');
    });
}